import { render, staticRenderFns } from "./FilterWells.vue?vue&type=template&id=70db8fde"
import script from "./FilterWells.vue?vue&type=script&lang=js"
export * from "./FilterWells.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports